export default __webpack_public_path__ + "static/media/Logo.57edfa61.png";